import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import MenuPage from './MenuPage';
import AnimateOnScroll from './components/AnimateOnScroll';
import Header from './components/Header';
import BlurText from './components/BlurText';
// import { useScrollPosition } from './hooks/useInView'; // Removed unused import

function Home() {
  // const scrollY = useScrollPosition(); // Removed unused variable
  
  return (
    <div className="App">
      <Helmet>
        <title>WakaGyros – Görög gyros, friss alapanyagok, gyors kiszolgálás</title>
        <meta name="description" content="Fedezd fel a WakaGyros autentikus görög ízeit: gyros tálak, piták, boxok, mártogatósok. Friss alapanyagok, gyors kiszolgálás Budapest szívében." />
        <link rel="canonical" href="https://www.wakagyros.hu/" />
        <meta property="og:title" content="WakaGyros – Autentikus görög gyros" />
        <meta property="og:description" content="Gyros tálak, piták, boxok és desszertek – friss alapanyagokkal." />
        <meta property="og:url" content="https://www.wakagyros.hu/" />
      </Helmet>
      
      {/* Unified Header */}
      <Header />

        {/* 1. Hero Section - Görög Gyros Élmény */}
        <section id="home" className="hero section-pattern" aria-labelledby="hero-title">
          <div className="hero-background">
            <img 
              src="/chicken_gyro_22340_16x9.jpg" 
              alt="WakaGyros autentikus görög gyros friss alapanyagokkal és tzatzikivel"
              className="hero-bg-image"
              fetchpriority="high"
              loading="eager"
            />
            <div className="hero-overlay"></div>
          </div>
          <div className="container">
            <div className="hero-content">
              <AnimateOnScroll animation="fade-up" className="hero-text">
                <BlurText 
                  text="Görög Gyros Élmény"
                  className="hero-title-blur"
                  delay={150}
                  animateBy="words"
                  direction="top"
                />
                <div className="hero-buttons" style={{ marginTop: '2rem' }}>
                  <a href="#menu" className="btn" aria-describedby="hero-title">Megnézem a menüt</a>
                </div>
              </AnimateOnScroll>
          </div>
        </div>
      </section>

      {/* 2. About Section */}
      <section id="about" className="section section-pattern" aria-labelledby="about-title">
        <div className="container">
          <div className="about-content">
            <AnimateOnScroll animation="fade-left" className="about-text">
              <h2 id="about-title">Rólunk</h2>
              <p className="text-prose">Szenvedélyünk a gyros, küldetésünk az élmény.</p>
              <p className="text-prose">Nálunk minden falatban ott van Görögország íze – friss alapanyagok, gondosan válogatott húsok, ropogós zöldségek és eredeti görög fűszerek. Nem hiszünk a kompromisszumokban: a minőség és az íz nálunk mindig első helyen áll.</p>
              <p className="text-prose">A célunk egyszerű: olyan gyrost készíteni, amitől minden vendég úgy érzi, hogy egy pillanatra a tengerparti nyaralását idézi fel. Gyors kiszolgálás, bőséges adagok és barátságos hangulat vár mindenkit.</p>
              <p className="text-prose"><strong>Mi nem csak ételt adunk, hanem élményt is – mert a gyros nálunk több, mint egy fogás.</strong></p>
            </AnimateOnScroll>
            <AnimateOnScroll animation="fade-right" delay={200} className="about-image">
              <div className="about-visual">🏛️</div>
            </AnimateOnScroll>
          </div>
        </div>
      </section>

      {/* 3. Menu Section */}
      <section id="menu" className="section" aria-labelledby="menu-title">
        <div className="container">
          <AnimateOnScroll animation="fade-up">
            <h2 id="menu-title" className="section-title">Menü</h2>
            <p className="section-subtitle">Fedezd fel autentikus görög ízeket és friss alapanyagokat</p>
          </AnimateOnScroll>
          <AnimateOnScroll animation="fade-up" delay={200}>
            <MenuPage />
          </AnimateOnScroll>
        </div>
      </section>

      {/* 4. Contact Section - Address, Order, etc. */}
      <footer id="kapcsolat" className="footer" role="contentinfo" aria-labelledby="contact-title">
        <div className="container">
          <h2 id="contact-title" className="sr-only">Kapcsolat</h2>
          <div className="footer-content">
            <div className="footer-column">
              <h3>Cím / elérhetőség</h3>
              <p>WakaGyros</p>
              <p>123 Fő utca</p>
              <p>Budapest, 1051</p>
              <p>📞 +36 1 234 5678</p>
              <p>📧 info@wakagyros.hu</p>
            </div>
            <div className="footer-column">
              <h3>Asztalfoglalás / rendelés</h3>
              <p>Online rendelés: wakagyros.hu</p>
              <p>Telefonos rendelés: +36 1 234 5678</p>
              <p>Asztalfoglalás: +36 1 234 5679</p>
              <div className="footer-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2689.514629987635!2d19.053!3d47.4979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4741dc40e8d0%3A0x0!2sWakaGyros%2C%201051%20Budapest%2C%20F%C5%91%20utca!5e0!3m2!1shu!2shu!4v1700000000000!5m2!1shu!2shu"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="WakaGyros helyszín térképe"
                />
              </div>
            </div>
            <div className="footer-column">
              <h3>Nyitvatartás / közösségi</h3>
              <p>Hétfő - Péntek: 10:00 - 22:00</p>
              <p>Szombat: 11:00 - 23:00</p>
              <p>Vasárnap: 12:00 - 21:00</p>
              <div className="social-icons">
                <button type="button" className="social-btn" aria-label="Facebook">📘</button>
                <button type="button" className="social-btn" aria-label="Instagram">📷</button>
                <button type="button" className="social-btn" aria-label="Twitter">🐦</button>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 WakaGyros. Minden jog fenntartva.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Home />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;

